import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { ref: "d" }
const _hoisted_2 = {
  class: "base-form filter",
  style: {"margin-left":"0"}
}
const _hoisted_3 = {
  class: "base-form filter",
  style: {"margin-left":"0"}
}
const _hoisted_4 = {
  class: "base-form filter",
  style: {"margin-left":"0"}
}
const _hoisted_5 = {
  class: "base-form filter",
  style: {"margin-left":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isVisible) = $event)),
    onClosed: _ctx.onDialogClosed,
    style: _normalizeStyle([{'min-height': `${_ctx.dialogWindowMinHeight}px`}, {"min-width":"800px","width":"calc(40% - 2rem)","height":"calc(60% - 2rem)"}])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 14,
              style: {"text-align":"right"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.tableSearchQuery,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableSearchQuery) = $event)),
                    style: {"max-width":"600px"},
                    placeholder: "Поиск по имени, фамилии, отчеству, телефону или e-mail",
                    class: "input-with-select"
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.tablePositionsFilter,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tablePositionsFilter) = $event)),
                    multiple: "",
                    clearable: "",
                    placeholder: "Фильтр по должностям",
                    onChange: _ctx.fetchEmployeesAsync
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeePositions, (p) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: p.id,
                          value: p.id,
                          label: p.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("   ")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.tableBranchesFilter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tableBranchesFilter) = $event)),
                    disabled: "",
                    clearable: "",
                    placeholder: "Фильтр по подразделению",
                    onChange: _ctx.fetchEmployeesAsync
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employerBranches, (p) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: p.id,
                          value: p.id,
                          label: p.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    onClick: _ctx.onAssignEmployeesClick,
                    disabled: !_ctx.selectedAssignees.length,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Назначить " + _toDisplayString((_ctx.selectedAssignees.length ? `(${_ctx.selectedAssignees.length})` : '')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_scrollbar, {
              style: _normalizeStyle({width: '100%', 'height': `${_ctx.scrollableContainerHeight}px` })
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  ref: "employeesTableRef",
                  "row-key": "id",
                  sortable: "custom",
                  data: _ctx.tableData,
                  "show-header": false,
                  "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
                  onSortChange: _ctx.onTableSortingChange,
                  onCellClick: _ctx.onTableCellClick,
                  style: _normalizeStyle({height: `${_ctx.scrollableContainerHeight * .8}px`})
                }, {
                  empty: _withCtx(() => [
                    _createTextVNode(" Список сотрудников пуст ☹️ ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { width: "40" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_checkbox, {
                          onChange: _cache[3] || (_cache[3] = (_, e) => _ctx.onTableRowSelectionChange(e)),
                          modelValue: scope.row.isAssigneeSelected,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.isAssigneeSelected) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Сотрудник",
                      prop: "employee"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.employee.lastname) + " " + _toDisplayString(scope.row.employee.firstname) + " ", 1),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_text, {
                            type: "info",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.employee.position.name) + _toDisplayString(!!scope.row.employee.positionGrade?.name ? `, ${scope.row.employee.positionGrade.name}` : ''), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", null, [
                          (!!scope.row.employee.fireDate)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                size: "small",
                                type: "warning",
                                effect: "plain"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Уволен")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data", "default-sort", "onSortChange", "onCellClick", "style"])), [
                  [_directive_loading, _ctx.tableLoading]
                ])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        })
      ], 512)
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed", "style"]))
}